export const PremierContractType = {
  NoContract: 0, // API could map to null for no contract type
  VariableGTM: 4, // 1,2,3,4 reserved for VariabltGTM of different variation per tbl_PremierContract
  Subscription: 5, // Contains Standard, Transition Offer and Finance Offer (various payment types)
  Hybrid: 6, // Hybrid
};

export const PremierContractTypeId = {
  0: 'NoContract',
  4: 'VariableGTM',
  5: 'Subscription',
  6: "Hybrid"
};

export const PremierPaymentStatusType = {
  Undefined: 0,
  NotPaid: 1,
  Paid: 2,
  Failed: 3,
  OnHold: 4,
  Refunded: 5,
  Waived: 6,
  Invoiced: 7,
};

export const PremierPaymentStatusTypeId = {
  0: 'Undefined',
  1: 'NotPaid',
  2: 'Paid',
  3: 'Failed',
  4: 'OnHold',
  5: 'Refunded',
  6: 'Waived',
  7: 'Invoiced',
};